module.exports = {
    OKDISCOUNTS_EXTERNAL_CODE_PROMOS: [
        'just_eat'
    ],
    OKDISCOUNTS_EXTERNAL_CODE_ERRORS: {
        CUSTOM: 'CUSTOM',
        GENERIC: 'GENERIC'
    }
};
